import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ResolveTranslateAbleTextPipe, type TranslateAbleText } from '@pct-ng/i18n';

@Component({
  selector: 'cappus-field-label',
  templateUrl: './field-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ResolveTranslateAbleTextPipe],
})
export class FieldLabelComponent {
  readonly label = input.required<TranslateAbleText>();
  readonly required = input.required<boolean>();
}
